<section class="mb-2 mt-2 rounded-t-xl">
  <div #headerContainer>
    <div
      class="flex flex-col justify-between px-4 sm:flex-row md:flex-col xl:flex-row"
    >
      <div class="flex items-center pt-1">
        <mat-icon class="mr-2 mt-0.5">build</mat-icon>
        <h1>Tickets ({{ totalTickets || 0 }})</h1>
      </div>
      <div
        class="flex flex-col items-center justify-between gap-2 py-4 sm:flex-row xl:my-0"
      >
        <app-csv-download
          [csvData]="csvData"
          [fileName]="'Tickets.csv'"
          [iconOnly]="false"
        ></app-csv-download>
        <button
          class="btn-primary"
          *ngxPermissionsOnly="'Ticketing: Write'"
          (click)="openDialog()"
        >
          Create Ticket
        </button>
      </div>
    </div>
    <!-- search-wrapper -->
    <div class="flex justify-between px-4 pb-4 xl:pt-2">
      <mat-form-field>
        <mat-icon class="absolute mr-1">search</mat-icon>
        <input
          matInput
          [formControl]="searchTermControl"
          placeholder="Search By Case Number"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div class="group-wrapper font-montserrat">
      <div class="group-label">
        <mat-icon class="text-white">swap_vert</mat-icon>
        <span>Group By: </span>
      </div>
      <div class="group-options">
        <a
          (click)="onClickGroupBy('Location')"
          class="group-option"
          [ngClass]="{
            'active-link font-bold opacity-100 outline-none after:block':
              currentGrouping === 2,
          }"
        >
          <span>
            Location
            @if (currentGrouping === 2) {
              <mat-icon class="ml-1 text-base text-white">
                {{ isOrderingAsc ? 'arrow_upward_alt' : 'arrow_downward_alt' }}
              </mat-icon>
            }
          </span>
        </a>
        <a
          (click)="onClickGroupBy('Status')"
          class="group-option"
          [ngClass]="{
            'active-link font-bold opacity-100 outline-none after:block':
              currentGrouping === 1,
          }"
        >
          <span>
            Status
            @if (currentGrouping === 1) {
              <mat-icon class="ml-1 text-base text-white">
                {{ isOrderingAsc ? 'arrow_upward_alt' : 'arrow_downward_alt' }}
              </mat-icon>
            }
          </span>
        </a>
        <a
          (click)="onClickGroupBy('Type')"
          class="group-option"
          [ngClass]="{
            'active-link font-bold opacity-100 outline-none after:block':
              currentGrouping === 0,
          }"
        >
          <span>
            Type
            @if (currentGrouping === 0) {
              <mat-icon class="ml-1 text-base text-white">
                {{ isOrderingAsc ? 'arrow_upward_alt' : 'arrow_downward_alt' }}
              </mat-icon>
            }
          </span>
        </a>
      </div>
    </div>
  </div>

  <!-- Ticket List Wrapper -->
  <div class="relative min-h-[300px]">
    @if (isLoading) {
      <div
        class="absolute inset-0 z-10 flex items-center justify-center rounded bg-white/60 backdrop-blur-sm"
      >
        <mat-progress-spinner
          mode="indeterminate"
          color="primary"
        ></mat-progress-spinner>
      </div>
    } @else if (groupedTickets.length === 0 && tickets.length === 0) {
      <div
        class="relative w-full pt-8 text-center font-normal after:ml-4 after:mt-8 after:block after:h-px after:bg-gray-300 after:content-['']"
      >
        @if (tickets.length === 0) {
          <span>
            {{
              (searchTermControl?.value?.length || 0) === 0
                ? 'No tickets have been created yet. Create a ticket to get started.'
                : 'No tickets match your search. Try different keywords.'
            }}
          </span>
        }
      </div>
    } @else if (groupedTickets.length > 0) {
      <div class="ticket-viewport">
        <mat-accordion
          [class.opacity-40]="isLoading"
          [class.pointer-events-none]="isLoading"
          displayMode="flat"
          class="transition-opacity duration-300 ease-in-out"
        >
          <mat-expansion-panel
            *ngFor="
              let ticketGroup of groupedTickets;
              let i = index;
              first as isFirst
            "
            [id]="'ticket-group-' + ticketGroup.key"
            (afterExpand)="onExpanded()"
            [expanded]="shouldExpand(ticketGroup, isFirst)"
            (click)="onHeaderClick($event)"
          >
            <mat-expansion-panel-header class="items-center font-lato">
              <mat-panel-title>
                <div
                  class="!font-lato text-base uppercase"
                  [ngClass]="{
                    'text-xs lg:text-sm xl:text-base': currentGrouping === 2,
                  }"
                >
                  {{ ticketGroup.key || 'N/A' | uppercase }}
                </div>
              </mat-panel-title>

              <mat-panel-description
                class="!mr-0 !flex-none !overflow-visible !whitespace-nowrap"
              >
                <span class="text-sm font-normal">
                  Total Number Tickets: {{ ticketGroup.tickets.length }}
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div>
              <div
                *ngFor="let ticket of ticketGroup.tickets"
                tabindex="0"
                class="border-gray cursor-pointer border-b text-blue-950 last:border-b-0 hover:bg-blue-50 focus:bg-blue-50"
                [ngClass]="{
                  'bg-blue-50': ticket?.Id === selectedTicketId,
                }"
              >
                <div
                  class="relative grid grid-cols-[auto,1fr,auto] items-start gap-x-4 px-5 py-2"
                >
                  <!-- Col 1: Case # -->
                  <div
                    class="hidden whitespace-nowrap break-all text-sm lg:block"
                  >
                    {{ ticket.CaseNumber }}
                  </div>

                  <!-- Col 2: Subject + Address -->
                  <div class="min-w-0">
                    <div
                      class="block whitespace-nowrap break-all text-sm lg:hidden"
                    >
                      {{ ticket.CaseNumber }}
                    </div>
                    <div
                      class="overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      {{ ticket.Subject }}
                    </div>
                    <div
                      class="overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      <mat-icon
                        class="!h-4 !w-3 align-middle text-xs leading-none"
                        >location_on</mat-icon
                      >
                      {{
                        ticket.Service_Location_Address__c || 'N/A' | uppercase
                      }}
                    </div>
                  </div>

                  <!-- Col 3: Status + Right Arrow -->
                  <div
                    class="-mt-2 flex items-center justify-self-end text-right"
                  >
                    <div>
                      <div
                        class="pt-1 text-lg font-semibold"
                        [ngClass]="{
                          'text-red-500': !ticket.IsClosed,
                          'text-green-500': ticket.IsClosed,
                        }"
                      >
                        {{ ticket.IsClosed ? 'CLOSED' : 'OPEN' }}
                      </div>
                      <div class="font-normal text-gray-600">
                        @if (ticket.IsClosed) {
                          <span class="hidden sm:inline-block">closed</span>
                          {{ (ticket.ClosedDate | date: 'M.d.yy') || '---' }}
                        } @else {
                          <span class="hidden sm:inline-block">opened</span>
                          {{ (ticket.CreatedDate | date: 'M.d.yy') || '---' }}
                        }
                      </div>
                    </div>
                    <div class="pl-4">
                      <div class="flex justify-end">
                        <mat-icon class="!h-8 !w-8 text-3xl text-blue-500"
                          >chevron_right</mat-icon
                        >
                      </div>
                      <span
                        class="flex items-center justify-end text-sm text-gray-600"
                      >
                        <mat-icon class="pr-1 pt-0.5 text-sm">comment</mat-icon>
                        {{ ticket.Comments__r?.totalSize || 0 }}
                      </span>
                    </div>
                  </div>

                  <a
                    [routerLink]="['/tickets', ticket.Id]"
                    tabindex="-1"
                    class="absolute inset-0 block opacity-0 md:hidden"
                  ></a>
                  <a
                    (click)="onSelectTicket(ticket)"
                    tabindex="-1"
                    class="absolute inset-0 hidden opacity-0 md:block"
                  ></a>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- <div class="ticket-list-paginator my-2 flex justify-center">
          <mat-paginator
            [length]="totalTickets"
            [pageSize]="pageSize"
            [pageIndex]="currentPage ?? 0"
            [pageSizeOptions]="[20, 50, 100]"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div> -->
      </div>
    }
  </div>
</section>
